<template>
  <div>
    <v-container>
      <v-form ref="form">
        <v-row>
          <v-col>
            <h2 class="pb-5">{{ this.pageTitle }}</h2>
          </v-col>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n6 pt-6">
            <v-autocomplete
              outlined
              :label="this.$t('pmrewardposting.rewardsimulationdesc')"
              type="text"
              :rules="[rules.required]"
              :items="rewardSimulationList"
              v-model="formData.rewardsimulationid"
              @change="changeRewardSimulation(formData.rewardsimulationid)"
              dense
            ></v-autocomplete>
          </v-col>

          <v-col cols="4" sm="4" class="pb-n5 mt-n6 pt-6">
            <v-text-field
              outlined
              :label="this.$t('pmrewardposting.rewardsimulationcode')"
              type="text"
              v-model="simulationcode"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmassementrecord.pmassessmentdesc')"
              type="text"
              v-model="pmassessmentrecorddesc"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmassementrecord.pmassessmentcode')"
              type="text"
              v-model="pmassessmentrecordcode"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmmoderation.periodfromdate')"
              type="date"
              v-model="periodfromdate"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmmoderation.perioduntildate')"
              type="date"
              v-model="perionenddate"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.status')"
              type="text"
              v-model="rewardstatus"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.recorddate')"
              type="date"
              v-model="formData.recorddate"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.recordtypedesc')"
              type="text"
              v-model="recordtypedesc"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.recordtypecode')"
              type="text"
              v-model="recordtypecode"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.reasoncodedesc')"
              type="text"
              v-model="reasondesc"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('generateunpaidleaverecord.reasoncode')"
              type="text"
              v-model="reasoncode"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmreviewexercise.servicerecordasatdate')"
              type="date"
              v-model="servicerecdate"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('pmreviewexercise.cessationcutoffdate')"
              type="date"
              v-model="cessacutoffdate"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <app-parameter 
            class="mt-1 mb-5"
            v-on:input="parameters = $event"
            v-bind:parentObject="{
                parameters: this.parameters,
                filter: this.showFilter,
            }"
        /> 

        <v-row dense>
          <div class="btn-process" style="margin-right: 70px;">
            <v-btn color="primary" style="width: 150px" @click="onPost">
              {{$t('button.post')}}
            </v-btn>
          </div>

          <div class="btn-process">
            <v-btn color="primary" style="width: 150px" @click="onUnPost">
              {{$t('button.undoposting')}}
            </v-btn>
          </div>
        </v-row>
      </v-container>
      </v-form>
    </v-container>

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ErrorDialog from "../../../components/common/ErrorDialog";
import "vue-loading-overlay/dist/vue-loading.css";
import FilterParameter from '../../../components/performance/reviewexercise/FilterParameter';

export default {

  components: {
    "app-error": ErrorDialog,
    'app-parameter': FilterParameter,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        },
      },
      // pageTitle: this.$t('postpayroll.leavepostingtopayroll'),
      //pageTitle: "Performance Salary Increment Posting to Staff Record",

      formData: {
        rewardsimulationid: null,
        recorddate: null,
        actualeffectivedate: null,
        currencyid: null,
        userid: this.$store.getters.userId,
      },

      //Filter Parameters
      parameters: {
            companyid: null,
            compnyname: null,
            branchid: null,
            brchname: null,
            departmentid: null,
            deptname: null,
            divisionid: null,
            divnname: null,
            sectionid: null,
            sectioname: null,
            unitid: null,
            unitname: null,
            gradeid: null,
            grddesc: null,
            employmenttypeid: null,
            emptypecatdesc: null,
            staffid: null,
            staffcode: null,
      },

      showFilter: {
          companyid: true,
          branchid: true,
          departmentid: true,
          divisionid: true,
          sectionid: true,
          unitid: true,
          gradeid: true,
          employmenttypeid: true,
          staffid: true,
      },

      leavecode: null,
      payeeinputdetail: null,
      payoutdesc: "",
      pymonth: "",
      pyyear: "",
      grouppdesc: "",

      pmassessmentrecorddesc: "",
      pmassessmentrecordcode: "",
      recordtypedesc: "",
      recordtypecode: "",
      reasoncode: "",
      reasondesc: "",
      recorddate: null,
      servicerecdate: null,
      cessacutoffdate: null,
      periodfromdate: null,
      perionenddate: null,
      rewardstatus: "",
      simulationcode: "",
      posted: false,
      
      errMsg: "",
      isErr: false,
      loading: true,

      rewardSimulationList: [],
    };
  },

  computed: {
    pageTitle() {
        return this.$t('pmrewardposting.performancesalaryincrepostingtostaffrec');
    }
  },

  methods: {

    onUnPost() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      if (this.posted == 0) {
        this.isErr = true;
        this.errMsg = this.$t('pmrewardposting.notpostedyet');
        return;
      } else if (this.posted == 1) {
          if ((this.$refs.form.validate())){
          this.$store.dispatch('put', {url: "/reward/incrementpostingundo", payload: this.formData})
            .then((res) => {
              let dataholder = res.data.rec;

              if (res.data.status != 409) {
                let item = {
                  processedCount: dataholder.unposted,
                  staffprocessedCount: dataholder.staffprocess,
                  totalUnPosted: dataholder.unposted,
                }
              
                this.$router.push({ name: "pmrewardincrementpostinglog", params: { item } });
              } else {
                vm.isErr = !vm.isErr;
                vm.errMsg = res.data.error;
              }
            })
            .catch((err) => {
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
            });
          }
      }
    },

    onPost() {
      const vm = this;

      if (this.posted == 1) {
        this.isErr = true;
        this.errMsg = this.$t('pmrewardposting.alreadyposted');
        return;
      } else if (this.posted == 0) {
          if ((this.$refs.form.validate())){
            this.$store.dispatch('post', {url: "/reward/incrementposting", payload: this.formData})
            .then((res) => {
              let dataholder = res.data.rec;
              console.log('res', res.data)

              if (res.data.status != 409) {
                let item = {
                  processedCount: dataholder.posted,
                  staffprocessedCount: dataholder.staffprocess,
                  totalPosted: dataholder.posted,
                }
                this.$router.push({ name: "pmrewardincrementpostinglog", params: { item } });
              } else {
                vm.isErr = !vm.isErr;
                vm.errMsg = res.data.error;
              }
              
            })
            .catch((err) => {
              console.log('err', err)
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
            });
          }
      }
    },

    changeRewardSimulation(id) {
      console.log('id', id)
      console.log('rewardSimulationList', this.rewardSimulationList);
      let item = this.rewardSimulationList.find((item) => item.id == id);

      console.log('item', item)
      this.pmassessmentrecorddesc = item.pmassessmentrecorddesc;
      this.pmassessmentrecordcode = item.pmassessmentrecordcode;
      this.recordtypedesc = item.recordtypedesc;
      this.recordtypecode = item.recordtypecode;
      this.reasoncode = item.reasoncode;
      this.reasondesc = item.reasondesc;
      this.formData.recorddate = moment(item.recorddate).format("YYYY-MM-DD");
      if(item.actualeffectivedate) {
        this.formData.actualeffectivedate = moment(item.actualeffectivedate).format("YYYY-MM-DD");
      }
      this.servicerecdate = moment(item.servicerecdate).format("YYYY-MM-DD");
      this.cessacutoffdate = moment(item.cessacutoffdate).format("YYYY-MM-DD");
      this.periodfromdate = moment(item.periodfromdate).format("YYYY-MM-DD");
      this.perionenddate = moment(item.perionenddate).format("YYYY-MM-DD");
      this.rewardstatus = item.rewardstatus;
      this.simulationcode = item.simulationcode;
      this.formData.currencyid = item.currencyid;
      this.posted = item.posted;
    },

    loadRewardSimulationHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/rewardsimulation/all"})
        .then((res) => {
          console.log('rewardSimulationList', res.data.rec)

          for (let i = 0; i < res.data.rec.length; i++) {
            
            vm.rewardSimulationList.push({
              text: res.data.rec[i].simulationdesc,
              value: res.data.rec[i].id,
              code: res.data.rec[i].simulationcode,
              ...res.data.rec[i], // Add the rest of the properties from res.data.rec[i]
            });
          }

        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  mounted() {
    this.loadRewardSimulationHandler();
  },
};
</script>

<style scoped>
.btn-process {
  margin-right: 120px;
  width: 100px;
}
</style>